import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GetClientRequest } from '../models/client.model';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { InputTypeEnum } from 'src/app/shared/input/enums/input-type.enum';
import { StatusEnum } from 'src/app/common/utils/status-enum.models';
import { MaskTypeEnum } from 'src/app/shared/input/enums/mask-type.enum';

@Component({
  selector: 'app-client-filter',
  templateUrl: './client-filter.component.html',
  styleUrls: ['./client-filter.component.scss']
})
export class ClientFilterComponent {
  constructor(public formBuilder: FormBuilder) {}

  @Output() filterEmmiter: EventEmitter<GetClientRequest> =
    new EventEmitter<GetClientRequest>();

  form = this.formBuilder.group({
    name: '',
    status: [[]],
    cnpj: '',
    initialDate: '',
    finalDate: '',
  });

  isOpen: boolean = false;
  status: string[] = [];
  selectedStatus: string[] = [];
  isLoading: boolean = false;

  get ButtonColorEnum() {
    return ButtonColorEnum;
  }

  get MaskTypeEnum() {
    return MaskTypeEnum;
  }

  get InputTypeEnum() {
    return InputTypeEnum;
  }

  ngOnInit() {
    this.populateStatus();
  }

  populateStatus() {
    this.status = [StatusEnum.ATIVO, StatusEnum.INATIVO];
  }

  handleToggleAccordion() {
    this.isOpen = !this.isOpen;
  }

  clear() {
    this.form.reset();
    this.selectedStatus = [];
  }

  search() {
    let filter: GetClientRequest = {} as GetClientRequest;

    filter.name = this.form.controls.name.value ?? '';
    filter.status = this.form.controls.status.value ?? null;
    filter.cnpj = this.form.controls.cnpj.value ?? '',
    filter.startDate = this.form.controls.initialDate.value ?? '';
    filter.endDate = this.form.controls.finalDate.value ?? '';

    this.filterEmmiter.emit(filter);

    this.isOpen = false;
  }
}
